import React from 'react'
import useDebounce from '../../../hooks/use-debounce'


export default ({
    value = '',
    onChange = () => {}
}) => {
    const [search, setSearch] = React.useState(value)
    //  Debounce any changes
    const debouncedSearch = useDebounce(search)
    //  Bubble debounced changes back up
    React.useEffect(() => {
        onChange(debouncedSearch)
    }, [debouncedSearch])

    const canSearch = Boolean(search);

    const onSearchClick = () => setSearch('');

    return {
        search,
        setSearch,
        canSearch,
        onSearchClick
    }
}